import { IOWidget, AsyncState, Fun, AsyncOptions, async, Action } from "widgets-for-react";

export type WithConnectionErrors<s> = {
  newResult: AsyncState<s>
  connectionErrorServer: boolean
  connectionErrorUser: boolean
}

export function asyncWithConnectionError<s>(w?: IOWidget<s, Fun<AsyncState<s>, AsyncState<s>>>, options?: AsyncOptions<s>): IOWidget<AsyncState<s>, Fun<AsyncState<s>,WithConnectionErrors<s>>> {
  return (s0: AsyncState<s>) =>
    async<s>(w, { ...options, retry: { maxAttempts: 10 } })(s0).map(updateResult => result => {
      let newResult = updateResult(result)
      let retried = newResult.retryCount || 0
      newResult.retryCount = result.kind != "loading" ? result.retryCount : newResult.kind == 'failed' ? retried + 1 : retried
      let connectionErrorUser = false
      let connectionErrorServer = newResult.kind == "failed" && newResult.status == 503 && newResult.retryCount == 10
      if (newResult.kind == "failed" && newResult.status == 503 && (!newResult.retryCount || newResult.retryCount < 10)) {
        newResult = { kind: "connection-error", p: newResult.p, cache: newResult.cache, retryCount: newResult.retryCount }
      }
      if (newResult.kind == "failed" && newResult.status == 0) {
        connectionErrorUser = true
      }
      return { newResult, connectionErrorServer, connectionErrorUser }
    })
}